export enum HeaderType {
  AUTHORIZATION = 'Authorization',
  CONTENT_TYPE = 'Content-Type',
  X_ACTION_ID = 'X-Action-Id',
  X_MENU_ID = 'X-Menu-Id',
  X_API_KEY = 'X-Api-Key',
  X_USER_IP = 'X-User-Ip',
  X_USER_DEVICE = 'X-User-Device',
  X_USER_LOCATION = 'X-User-Location',
  X_OTP_TOKEN = 'X-Otp-Token',
  X_MFA_TOKEN = 'X-Mfa-Token',
  X_CAPTCHA_TOKEN = 'X-Captcha-Token',
}
